import { useEffect, useState } from 'react'

export const usePageHeading = (): string => {
  const [heading, setHeading] = useState('')

  useEffect(() => {
    const headingElement = document.querySelector('h1')
    const headingText = headingElement?.textContent?.trim() ?? ''
    setHeading(headingText)
  }, [])
  return heading
}
